import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { StepImageUploadOnFeedFragmentDoc } from './step-image-upload.fragment.generated';
import { VideoUploadOnFeedFragmentDoc } from '../../video-uploads/__generated__/video-uploads-query.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateStepImageUploadMutationVariables = Types.Exact<{
  input: Types.CreateStepImageUploadInput;
}>;


export type CreateStepImageUploadMutation = { __typename?: 'RootMutationType', createStepImageUpload?: { __typename?: 'StepImageUploadResult', stepImageUpload?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, name?: string | null, rawUrl?: string | null, alternativeText?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, duration?: number | null, size?: number | null, insertedAt?: any | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null, narration?: { __typename?: 'ContentNarration', id: string, title?: string | null, type?: Types.NarrationType | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, thumbUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null } | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const CreateStepImageUploadDocument = gql`
    mutation createStepImageUpload($input: CreateStepImageUploadInput!) {
  createStepImageUpload(input: $input) {
    stepImageUpload {
      ...StepImageUploadOnFeed
    }
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      providerName
      videoContain
      video {
        ...VideoUploadOnFeed
      }
      image {
        ...StepImageUploadOnFeed
      }
      narration {
        id
        title
        type
        video {
          id
          rawUrl
          transcodedUrl
          previewUrl
          streamUrl
          thumbUrl
          gifUrl
          gifWithIconUrl
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${StepImageUploadOnFeedFragmentDoc}
${VideoUploadOnFeedFragmentDoc}`;
export type CreateStepImageUploadMutationFn = Apollo.MutationFunction<CreateStepImageUploadMutation, CreateStepImageUploadMutationVariables>;

/**
 * __useCreateStepImageUploadMutation__
 *
 * To run a mutation, you first call `useCreateStepImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStepImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStepImageUploadMutation, { data, loading, error }] = useCreateStepImageUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStepImageUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateStepImageUploadMutation, CreateStepImageUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStepImageUploadMutation, CreateStepImageUploadMutationVariables>(CreateStepImageUploadDocument, options);
      }
export type CreateStepImageUploadMutationHookResult = ReturnType<typeof useCreateStepImageUploadMutation>;
export type CreateStepImageUploadMutationResult = Apollo.MutationResult<CreateStepImageUploadMutation>;
export type CreateStepImageUploadMutationOptions = Apollo.BaseMutationOptions<CreateStepImageUploadMutation, CreateStepImageUploadMutationVariables>;